<template>
  <div>
    <!-- 搜索/新增 -->
    <div class="list-hd">
      <el-form :inline="true" v-model="searchValue" class="demo-form-inline">
        <el-form-item label="用户名:">
          <el-input v-model="searchValue.username"></el-input>
        </el-form-item>
        <el-form-item label="角色ID:">
          <el-input v-model="searchValue.role_id"></el-input>
        </el-form-item>
        <el-form-item label="所属游戏:">
          <el-select
            v-model="searchValue.game_id"
            filterable
            clearable
            placeholder="请选择"
            @change="selectChannel"
          >
            <el-option
              v-for="item in gamesList"
              :key="item.id"
              :label="item.name"
              :value="item.id"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="所属渠道:">
          <el-select
            v-model="searchValue.channel_id"
            filterable
            clearable
            placeholder="请选择"
          >
            <el-option
              v-for="item in channelSelectList"
              :key="item.id"
              :label="item.name"
              :value="item.id"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="渠道包组:">
          <el-select
            v-model="searchValue.group_channel_ids"
            filterable
            clearable
            placeholder="请选择"
          >
            <el-option
              v-for="item in channelGroupSelectList"
              :key="item.id"
              :label="item.group_name"
              :value="item.group_channel_ids"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="角色名:">
          <el-input v-model="searchValue.name"></el-input>
        </el-form-item>
        <el-form-item label="区名:">
          <el-input v-model="searchValue.zone_name"></el-input>
        </el-form-item>
        <el-form-item label="最后登录IP:">
          <el-input v-model="searchValue.last_login_ip"></el-input>
        </el-form-item>
        <el-form-item label="注册IP:">
          <el-input v-model="searchValue.register_ip"></el-input>
        </el-form-item>
        <el-form-item label="日期:">
          <el-date-picker
            v-model="date"
            type="datetimerange"
            value-format="yyyy-MM-dd HH:mm:ss"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            :default-time="['00:00:00', '23:59:59']"
            :picker-options="pickerOptions">
          </el-date-picker>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="searchRoleList">搜索</el-button>
        </el-form-item>
        <el-form-item>
          <el-button type="success" @click="exportRoles()">导出</el-button>
        </el-form-item>
      </el-form>
    </div>
    <el-table
      stripe
      ref="table"
      v-loading="loadingData"
      :data="tableData"
      :max-height="tableHeight"
      border
      style="width: 100%"
    >
      <el-table-column prop="role_id" label="角色ID" width="80"> </el-table-column>
      <el-table-column prop="user.created_at" label="用户创建日期" width="120"> </el-table-column>
      <el-table-column prop="created_at" label="角色创建日期" width="120"> </el-table-column>
      <el-table-column prop="user.username" label="用户名"> </el-table-column>
      <el-table-column prop="game.name" label="所属游戏"> </el-table-column>
      <el-table-column prop="channels.name" label="所属渠道"> </el-table-column>
      <el-table-column prop="name" label="角色名"> </el-table-column>
      <el-table-column prop="zone_name" label="区名"> </el-table-column>
      <el-table-column prop="level" label="等级"> </el-table-column>
      <el-table-column prop="reincarnation" label="转生等级"> </el-table-column>
      <el-table-column prop="user.ip" label="注册IP"> </el-table-column>
      <el-table-column prop="infos.last_login_ip" label="最后登录IP">
      </el-table-column>
      <el-table-column prop="logout_at" label="最近登出时间" width="150px">
      </el-table-column>
      <el-table-column v-if="showAmount" prop="amount" label="总充值金额"> </el-table-column>
      <el-table-column prop="day_num" label="用户流失时间" width="120px">
      </el-table-column>
      <el-table-column prop="user.phone" label="手机号"> </el-table-column>
      <el-table-column
        prop="last_login_at"
        label="最近登录时间"
        width="150px"
      >
      </el-table-column>
      <el-table-column fixed="right" label="操作" width="100">
        <template slot-scope="scope">
          <el-button
            type="danger"
            @click="delRole(scope.row)"
            >删除</el-button>
        </template>
      </el-table-column>
    </el-table>
    <!-- 分页 -->
    <div class="pagination">
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="currentPage"
        :page-sizes="[10, 20, 30, 40]"
        :page-size="pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="totalRecords"
      >
      </el-pagination>
    </div>
  </div>
</template>
<script>
import moment from "moment";
import { mapState } from "vuex";
import fetch from "@/assets/js/axios.js";
import { urlSplicing } from "@/assets/js/public.js";
export default {
  name: "roles",
  components: {},
  data() {
    return {
      pickerOptions: {
        disabledDate(time) {
          return time.getTime() > new Date(moment().format("YYYY-MM-DD") + ' 23:59:59').getTime()
        }
      },
      date: [],
      loadingData: false,
      searchValue: {
        username: "",
        name: "",
        game_id: "",
        channel_id: "",
        zone_name: "",
        role_id: "",
        last_login_ip: "",
        group_channel_ids: "",
        register_ip: "",
      },
      tableHeight: 0,
      historyValue: {},
      tableData: [],
      totalRecords: 0,
      currentPage: 1,
      pageSize: 10,
      gamesList: [],
      channelSelectList: [],
      channelSelectAllList: [],
      channelGroupSelectList: [],
      rules: {
        name: [{ required: true, message: "请输入用户名", trigger: "blur" }],
      },
      showAmount: false,
    };
  },
  computed: {
    ...mapState(["host"]),
  },
  created() {
    this.getGameSelectList();
    this.getChannelSelect();
    this.channelGroupSelect();
    this.getRoleList(true);
  },
  updated() {
    this.$nextTick(() => {
      this.$refs["table"].doLayout();
    });
  },
  beforeMount(height) {
    var h = document.documentElement.clientHeight;
    this.tableHeight = h - 60; //减去页面上固定高度height
  },

  methods: {
    delRole ({list_id, name, zone_name}) {
      this.$confirm(`是否确认删除'${zone_name}'——'${name}'?`, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        fetch({
          url: 'admin/user_role/del_role',
          method: 'GET',
          params: {
            list_id
          }
        }).then(res => {
          if (res.data.status) {
            this.$message.success('删除成功')
            this.getRoleList(true);
          } else if (res.data.message) {
            this.$message.error(res.data.message)
          }
        })
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消删除'
        })        
      })
    },
    handleSizeChange(val) {
      this.pageSize = val;
      this.getRoleList(false);
    },
    handleCurrentChange(val) {
      this.currentPage = val;
      this.getRoleList(false);
    },

    // 导出
    exportRoles() {
      let params = {
        ...this.historyValue, // 传对应的搜索的值
        export: 1,
        token: sessionStorage.getItem("access_token"),
      }
      if (this.date && this.date.length) {
        const created_from = this.date.length === 2 && this.date[0]
        const created_to = this.date.length === 2 && this.date[1]
        if (created_from) params['created_from'] = created_from
        if (created_to) params['created_to'] = created_to
      }

      urlSplicing(this.host + "admin/user_role/list", params);
    },

    // 获取游戏选择列表数据
    getGameSelectList(row) {
      fetch({
        url: "/admin/games/select",
        method: "GET",
      }).then((res) => {
        this.gamesList = res.data.data;
      });
    },
    // 获取渠道选择列表数据
    getChannelSelect(row) {
      fetch({
        url: "/admin/channels/select",
        method: "GET",
      }).then((res) => {
        this.channelSelectAllList = res.data.data;
        this.channelSelectList = res.data.data;
      });
    },
    // 渠道包组 下拉选择列表
    channelGroupSelect() {
      fetch({
        url: "/admin/channel_package_group/select",
        method: "GET",
      }).then((res) => {
        this.channelGroupSelectList = res.data.data;
      });
    },
    // 根据所属游戏,显示对应的所属渠道
    selectChannel(vid) {
      let obj = {};
      obj = this.gamesList.find((item) => {
        return item.id == vid;
      });
      this.channelSelectList = [];
      this.channelSelectAllList.forEach((item, i) => {
        if (obj) {
          if (item.game_id == obj.id) {
            this.channelSelectList.push(item);
          }
        } else {
          this.channelSelectList.push(item);
        }
      });
    },
    // 实现用户数据的搜索
    searchRoleList() {
      this.currentPage = 1;
      this.getRoleList(true);
    },
    // 展示用户角色列表数据
    getRoleList(reload = false) {
      let searchValue = {};
      if (reload) {
        this.historyValue = JSON.parse(JSON.stringify(this.searchValue));
        searchValue = this.searchValue;
      } else {
        searchValue = this.historyValue;
      }
      this.loadingData = true;
      const params = {
        ...searchValue,
        page: this.currentPage,
        per_page: this.pageSize,
      }
      if (this.date && this.date.length) {
        const created_from = this.date.length === 2 && this.date[0]
        const created_to = this.date.length === 2 && this.date[1]
        if (created_from) params['created_from'] = created_from
        if (created_to) params['created_to'] = created_to
      }
      fetch({
        url: "/admin/user_role/list",
        method: "GET",
        params,
      })
        .then((res) => {
          if (res.data.status) {
            this.tableData = res.data.data.data;
            this.totalRecords = res.data.data.total;
            let nowDate = new Date();
            let year = nowDate.getFullYear();
            let month =
              nowDate.getMonth() + 1 < 10
                ? "0" + (nowDate.getMonth() + 1)
                : nowDate.getMonth() + 1;
            let day =
              nowDate.getDate() < 10
                ? "0" + nowDate.getDate()
                : nowDate.getDate();
            let current_date = year + "-" + month + "-" + day;

            this.tableData.forEach((item, index) => {
              if (!index) this.showAmount = 'amount' in item
              if (item.logout_at !== null) {
                let start_time = item.logout_at.split(" ")[0];
                let startDate = Date.parse(start_time);
                let endDate = Date.parse(current_date);
                this.tableData[index]["day_num"] =
                  (endDate - startDate) / (1 * 24 * 60 * 60 * 1000);
              }
            });
          }
        })
        .finally(() => {
          this.loadingData = false;
        });
    },
  },
};
</script>
<style lang="less">
.pagination {
  text-align: right;
  margin-top: 20px;
  padding-bottom: 20px;
}
.list-hd {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  margin-bottom: 20px;
  .el-input-group {
    width: 370px;
  }
}
</style>
